// Vertical editorial timeline. items: [{label, title, text}]
export const Timeline = ({ items = [] }) => (
  <ol className="relative space-y-8 border-l-2 border-stone-line pl-8" data-testid="timeline">
    {items.map((item, i) => (
      <li key={i} className="relative">
        <span className="absolute -left-[41px] top-1 flex h-5 w-5 items-center justify-center rounded-full border-2 border-gold bg-travertine">
          <span className="h-2 w-2 rounded-full bg-gold" />
        </span>
        {item.label && (
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-gold-dark">
            {item.label}
          </span>
        )}
        <h4 className="mt-1 font-serif text-xl md:text-2xl font-medium text-charcoal">
          {item.title}
        </h4>
        {item.text && (
          <p className="mt-1.5 text-base leading-relaxed font-light text-slatey">
            {item.text}
          </p>
        )}
      </li>
    ))}
  </ol>
);

export default Timeline;
